import React, { useState, useEffect } from "react";
import "../ContactUs/Contact.css";
import API from "../Service/Baseservice";
import { useNavigate, useLocation } from "react-router-dom";
import Delete from "../../Assets/img/Delete.svg";
import Loading from "../../Loading/loading";



const EditSocial = () => {
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [heading, setHeading] = useState("");
  const location = useLocation();
  const [languageId, setLanguageId] = useState(
    location.state?.languageId || 1
  );
  const [socialSupportId, setSocialSupportId] = useState(null);
  const [contactId, setContactId] = useState(null);
  const [slink, setslink] = useState();
  const [errors, setErrors] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [deletePopup, setDeletePopup] = useState({
    show: false,
    item: null,
    index: null,
  });
  const [loading, setLoading] = useState(true);


  const [socialList, setSocialList] = useState([]);
  const [popup, setPopup] = useState({
    show: false,
    type: "",
    title: "",
    message: "",
  });

  const getIconByLink = (link) => {
    if (!link) return null;
    const l = link.toLowerCase();

    if (l.includes("instagram")) return "/social/instagram.png";
    if (l.includes("facebook")) return "/social/facebook.png";
    if (l.includes("youtube")) return "/social/youtube.png";
    if (l.includes("linkedin")) return "/social/linkidin.png";
    if (l.includes("twitter") || l.includes("x.com"))
      return "/social/twitter.png";

    return null;
  };

  const fetchData = () => {
    setLoading(true);

    API.post("SocialSupport_list/condition", {
      model: "SocialSupport_list",
      language_id: languageId,
    })
      .then((res) => {
        const data = res.data?.data?.data || [];

        if (data.length > 0) {
          const record = data[0];
          setTitle(record.title || "");
          setHeading(record.heading || "");
          setslink(record.sslink_id || "");
          setSocialSupportId(record.socialsupport_id || null);
          setContactId(record.contact_id || null);
        }
        const formatted = [];

        data.forEach((item) => {
          formatted.push({
            id: item.sslink_id,
            link: item.links || "",
            logo: item.media || "",
            preview: "",
            enabled: item.status === "active",
          });
        });


        setSocialList(formatted);


      })
      .catch((err) => console.error("Fetch error:", err))
      .finally(() => {
        setLoading(false); // ✅ THIS WAS MISSING
      });
  };

  const validateSocialList = () => {
    const newErrors = {};

    socialList.forEach((item, index) => {
      // skip completely empty + disabled rows
      if (
        !item.enabled &&
        !item.link &&
        !item.logo
      ) return;

      const rowErrors = {};

      if (!item.link?.trim()) {
        rowErrors.link = "Link is required";
      }

      if (!item.logo) {
        rowErrors.logo = "Icons is required";
      }

      if (Object.keys(rowErrors).length > 0) {
        // use id if exists, otherwise index
        const key = item.id ?? `new-${index}`;
        newErrors[key] = rowErrors;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };



  useEffect(() => {
    fetchData();
  }, [languageId]);

  const handleLinkChange = (index, value) => {
    setSocialList((prev) =>
      prev.map((item, i) =>
        i === index ? { ...item, link: value } : item
      )
    );
  };

  const handleToggle = (index) => {
    setSocialList((prev) =>
      prev.map((item, i) =>
        i === index ? { ...item, enabled: !item.enabled } : item
      )
    );
  };

  const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  const handleImageUpdate = async (e, index) => {
    const file = e.target.files[0];
    if (!file) return;

    const previewUrl = URL.createObjectURL(file);

    setSocialList((prev) =>
      prev.map((item, i) =>
        i === index ? { ...item, preview: previewUrl } : item
      )
    );

    try {
      const base64 = await fileToBase64(file);

      const payload = {
        name: "Admin Image",
        image: [
          {
            name: file.name,
            type: file.type,
            size: `${file.size} bytes`,
            base64,
          },
        ],
      };

      const res = await API.post("imageUpload/add", payload);
      const uploadedUrl = Array.isArray(res.data.url)
        ? res.data.url[0]
        : res.data.url;

      setSocialList((prev) =>
        prev.map((item, i) =>
          i === index
            ? { ...item, logo: uploadedUrl, preview: "" }
            : item
        )
      );
    } catch (err) {
      console.error("Image upload error:", err);
    }
  };
  //   const saveSocialSupport = async () => {

  //   if (!validateSocialList()) {
  //     return;
  //   }

  //   try {
  //     const payload = {
  //       model: "socialsupport_edit",
  //       socialsupport_id: socialSupportId,
  //       language_id: languageId,
  //       contact_id: contactId,
  //       title,
  //       heading,
  //       updatedBy: 1,


  //       social_links: socialList.map((item) => ({
  //         sslink_id: item.id,
  //         media: item.logo,
  //         links: item.link,
  //         status: item.enabled ? "active" : "inactive",
  //       })),
  //     };


  //     await API.post("socialsupport_edit/update", payload);

  //     setPopup({
  //       show: true,
  //       type: "success",
  //       title: "Success",
  //       message: "Social support updated successfully!",
  //     });
  //   } catch (error) {
  //     console.error(error);

  //     setPopup({
  //       show: true,
  //       type: "error",
  //       title: "Failed",
  //       message: "Update failed. Try again!",
  //     });
  //   }
  // };
  const saveSocialSupport = async () => {
    if (!validateSocialList()) return;

    try {
      const payload = {
        model: "socialsupport_edit",
        socialsupport_id: socialSupportId,
        language_id: languageId,
        contact_id: contactId,
        title,
        heading,
        updatedBy: 1,

        social_links: socialList.map(item => {
          const obj = {
            media: item.logo,
            links: item.link,
            status: item.enabled ? "active" : "inactive",
          };

          // 👈 ONLY existing rows send sslink_id
          if (item.id) {
            obj.sslink_id = item.id;
          }

          return obj;
        }),
      };

      await API.post("socialsupport_edit/update", payload);

      setPopup({
        show: true,
        type: "success",
        title: "Success",
        message: "Social support updated successfully!",
      });

      // 🔄 refresh to get new sslink_id from backend
      fetchData();
    } catch (error) {
      console.error(error);
      setPopup({
        show: true,
        type: "error",
        title: "Failed",
        message: "Update failed. Try again!",
      });
    }
  };





  const handleAddSocial = () => {
    setSocialList(prev => [
      {
        id: null,
        link: "",
        logo: "",
        preview: "",
        enabled: true,
      },
      ...prev,
    ]);

    setErrors({});
  };


  const handleDeleteSocial = async (item, index) => {

    if (!item.id) {
      setSocialList(prev => prev.filter((_, i) => i !== index));
      return;
    }

    try {
      await API.post("socialSupportLinksDelete/update", {
        sslink_id: item.id,
      });

      setSocialList(prev => prev.filter((_, i) => i !== index));

    } catch (error) {
      console.error("Delete failed:", error);
    }
  };

  const confirmDeleteSocial = async () => {
    const { item, index } = deletePopup;

    if (!item) return;

    if (!item.id) {
      setSocialList(prev => prev.filter((_, i) => i !== index));
      setDeletePopup({ show: false, item: null, index: null });
      return;
    }

    try {
      await API.post("socialSupportLinksDelete/update", {
        sslink_id: item.id,
      });

      setSocialList(prev => prev.filter((_, i) => i !== index));
    } catch (error) {
      console.error("Delete failed:", error);
    } finally {
      setDeletePopup({ show: false, item: null, index: null });
    }
  };

  return (
    <div className="newss-containeradd">
      <div className="service-header-bar">
        <h2 className="services-title1">Edit Social Support</h2>

        <div className="button-group">

          <div className="filter-block">
            <label>Language</label>
            <div className="input-container">
              <select
                value={languageId}
                className="input-field"
                onChange={(e) => setLanguageId(Number(e.target.value))}
              >
                <option value={1}>English</option>
                <option value={2}>Français</option>
              </select>
            </div>
          </div>
          <button className="language-save-btn" onClick={saveSocialSupport}>
            Save
          </button>

          <button
            style={{ marginTop: "24px" }}
            onClick={() => navigate("/contactus")}
            className="cancel-btn "
          >
            Back
          </button>

        </div>
      </div>

      {loading ? (
        <Loading />
      ) : (

        <div className="edit-social-container">
          <div className="left-form">

            <div className="form-group">
              <label>Title <span className="required-star">*</span></label>
              <input value={title} onChange={(e) => setTitle(e.target.value)} />
            </div>

            <div className="form-group">
              <label>Heading <span className="required-star">*</span></label>
              <input value={heading} onChange={(e) => setHeading(e.target.value)} />
            </div>

            <button className="addbutton" onClick={handleAddSocial}>
              Add +
            </button>

            {socialList.map((item, index) => {
              const fallbackIcon = getIconByLink(item.link);

              return (
                <div className="social-link-row" key={index}>

                  {/* ICON */}
                  <div className="social-input media-col">
                    <label className="logo">
                      Icons <span className="required-star">*</span>
                    </label>
                    <label htmlFor={`iconUpload-${index}`} className="icon-click">

                      <div className="social-icon-box">
                        {item.preview || item.logo || fallbackIcon ? (
                          <img
                            src={item.preview || item.logo || fallbackIcon}
                            alt="icon"
                            className="admin-image"
                          />
                        ) : (
                          <span className="no-icon">+</span>
                        )}
                      </div>
                    </label>
                    {errors[item.id ?? `new-${index}`]?.logo && (
                      <p className="error-text">
                        {errors[item.id ?? `new-${index}`].logo}
                      </p>
                    )}




                    <input
                      type="file"
                      id={`iconUpload-${index}`}
                      accept="image/png,image/jpeg,image/jpg,image/svg+xml"
                      style={{ display: "none" }}
                      onChange={(e) => handleImageUpdate(e, index)}
                    />
                  </div>

                  {/* LINK */}
                  <div className="social-input link-col">
                    {/* HEADER ROW */}
                    <div className="label-action-row">
                      <label className="logo">
                        Link <span className="required-star">*</span>
                      </label>

                      <div className="action-col">
                        <label className="link-switch">
                          <input
                            type="checkbox"
                            checked={item.enabled}
                            onChange={() => handleToggle(index)}
                          />
                          <span className="link-slider round">
                            <span className="link-switch-label">
                              {item.enabled ? "ON" : "OFF"}
                            </span>
                          </span>
                        </label>
                        <img
                          src={Delete}
                          alt="Delete"
                          className="admin-icon-btn"
                          onClick={() =>
                            setDeletePopup({ show: true, item, index })
                          }
                        />
                      </div>
                    </div>

                    {/* INPUT BELOW */}
                    <input
                      type="text"
                      value={item.link}
                      onChange={(e) => handleLinkChange(index, e.target.value)}
                    />

                    {errors[item.id ?? `new-${index}`]?.link && (
                      <p className="error-text">
                        {errors[item.id ?? `new-${index}`].link}
                      </p>
                    )}


                  </div>


                </div>
              );
            })}
          </div>
        </div>
      )}

      {popup.show && (
        <div className="popup-overlay">
          <div className={`popup-box popup-${popup.type}`}>
            <h3>{popup.title}</h3>
            <p>{popup.message}</p>
            <button
              className="btn ok-btn"
              onClick={() => setPopup({ ...popup, show: false })}
            >
              OK
            </button>
          </div>
        </div>
      )}
      {/*  Delete Confirmation Popup */}
      {deletePopup.show && (
        <div className="popup-overlay">
          <div className="popup-box">
            <h3>Confirm Delete</h3>
            <p>Are you sure you want to delete this social link?</p>

            <div className="popup-buttons">
              <button
                className="cancel-btn "
                onClick={() =>
                  setDeletePopup({ show: false, item: null, index: null })
                }
              >
                Cancel
              </button>

              <button
                className="btn delete-btn"
                onClick={confirmDeleteSocial}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

    </div>

  );
};

export default EditSocial;
